import apiClient from '../../../Services/ApiClient';
import useApiClient from '../../Base/Hooks/useApiClient';
import { Address } from '../../Base/Interfaces/Address';

export interface PatientData {
	sendEmailInvitation: boolean;
	patient: {
		salutationBefore?: string;
		salutationAfter?: string;
		firstName: string;
		lastName?: string;
		address?: Address;
		insuranceCompanyTermItemId?: string;
		contactPhoneNumber?: string;
		contactEmail?: string;
		insuranceNumber?: string;
		taj?: string;
		middleName?: string;
		motherLastName?: string;
		fatherLastName?: string;
		birthDate?: string;
		gender?: string;
		citizenship?: string;
		mothersFullname?: string;
		birthPlace?: string;
		pesel?: string;
		emso?: string;
		jmbg?: string;
	};
	legalRepresentative?: {
		firstName: string;
		lastName: string;
		email: string;
		phoneNumber?: string;
	};
	healthPlanCode?: string;
	healthPlanWorkplaceMemberId?: string;
	meta?: { [key: string]: any };
	createdByType?: string;
	createdById?: string;
	note?: string;
}

export default function useWorkplacePatient() {
	const { displayError } = useApiClient();
	const createPatient = async (data: PatientData, workplaceId: string) => {
		try {
			return apiClient.post(`/workplaces/${workplaceId}/patient`, data);
		} catch (e: any) {
			displayError(e);
		}
	};

	const validateBirthNumber = async (birthNumber: string) => {
		try {
			const validationResult: any = await apiClient.post(
				`/utils/birth-number`,
				{
					birthNumber,
				},
			);
			if (validationResult?.data?.birthNumber) {
				return true;
			}
			return false;
		} catch (e: any) {
			displayError(e);
		}
	};

	return { createPatient, validateBirthNumber };
}
